




























import { Vue, Component } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import dayjs from 'dayjs'
import WebSocketProvider from '@/websocket'
import { WebSocketMessageMode } from '@/websocket/constants'
import { WebSocketCallMessageTypes } from '@/websocket/receivers/call'
import { WebSocketClientInterface } from '@/websocket/types'
import { SynchronizedStorage } from '@/synchronizedStorage'
import { reloadApp } from '@/utils'

@Component({
  components: {
    HeaderMenu: () => import('./HeaderMenu.vue')
  }
})
export default class Header extends Vue {
  $store!: ExStore
  blackout = false
  webSocket!: WebSocketClientInterface

  day = dayjs()

  async beforeCreate() {
    const sending = await SynchronizedStorage.BleAutoSending.get()
    this.$store.dispatch('ble/updateAutoSending', !!sending)
  }

  created() {
    this.day = dayjs()
    setTimeout(() => {
      this.day = dayjs()
      const id = setInterval(() => {
        this.day = dayjs()
      }, 1000 * 60 /* 1分ごとに時間を更新 */)

      this.$on('hook:beforeDestroy', () => {
        clearInterval(id)
      })
    }, 1000 * (60 - this.day.second()) /* 次に秒が繰り上がるときに実行 */)

    this.webSocket = WebSocketProvider.createConnection()
    this.webSocket.subscribeMessage(
      WebSocketMessageMode.CALL,
      WebSocketCallMessageTypes.REQUEST,
      this.handleReceiveCallRequest.bind(this)
    )
  }

  get isTop() {
    return this.$route.path === '/' || this.$route.path === '/r/'
  }

  get greeting() {
    const hour = this.day.hour()
    let greeting = 'こんばんは。'
    if (hour > 4 && hour < 11) greeting = 'おはようございます。'
    if (hour > 10 && hour < 18) greeting = 'こんにちは。'
    return greeting
  }

  get datetimeStr() {
    return this.day.format('M月D日(ddd)  HH:mm')
  }

  get userInfo() {
    return this.$store.getters['user/userInfo']
  }

  get userDisplayName() {
    const { lastName, firstName } = this.userInfo
    return lastName + firstName
  }

  async logout() {
    try {
      await this.$store.dispatch('user/logout')
      reloadApp()
    } catch (e) {
      console.error(e)
    }
  }

  handleReceiveCallRequest() {
    this.blackout = false
  }
}
